import {Directive, ElementRef, HostListener, Input, OnDestroy, OnInit} from '@angular/core';

@Directive({
    selector: '[tooltip]',
    standalone: true
})
export class TooltipDirective implements OnInit, OnDestroy {
  @Input() tooltip: string|(()=>string) = '';
  @Input('tooltipPlacement') placement: 'top'|'bottom'|'left'|'right' = 'top';
  @Input('tooltipDelay') delay = 2500;

  private ref: any;
  private timeout?: number;

  constructor(private readonly elementRef: ElementRef) {}

  ngOnInit() {
    const bootstrap = (window as any)['bootstrap'];
    if(bootstrap) {
      const title = typeof this.tooltip === 'function' ? this.tooltip : () => this.tooltip;
      this.ref = new bootstrap.Tooltip(this.elementRef.nativeElement, {title, placement: this.placement, trigger: 'hover focus', html: true, customClass: 'user-select-none'});
    }
  }

  @HostListener('shown.bs.tooltip')
  onShow() {
    if(this.timeout) {
      window.clearTimeout(this.timeout);
    }

    this.timeout = window.setTimeout(() => {
      this.ref?.hide();
    }, this.delay);
  }

  @HostListener('hidden.bs.tooltip')
  onHide() {
    window.clearTimeout(this.timeout);
    this.timeout = undefined;
  }

  ngOnDestroy() {
    if(this.ref) {
      this.ref.hide();
      setTimeout(()=>{
        try {
          this.ref?.dispose();
        } catch {}
      }, 2000);
    }
  }
}
